const listeTypesDocuments = [
    { code: "CNI", nom: "Carte Nationale d'identité", icon: "mdi-account-box-outline" },
    { code: "PASSPORT", nom: "Passeport", icon: "mdi-passport" },
    { code: "PERMIS", nom: "Permis de conduire", icon: "mdi-car" },
    //{ code: "RIB", nom: "Relevé d'Identité Bancaire", icon: "mdi-bank" },
];

export default listeTypesDocuments;